import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Winningdubai() {
  return (
    <section className="winning_dubai p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>
              We've Delivered 200+ Mobile App Solutions Across Multiple
              Industries!
            </h2>
          </Col>
          <Col xs={12} md={6} lg={5} className="offset-lg-1">
            <p>
              Understand consumer needs, proven business acumen, excel with
              novel technologies, and familiar with the dynamic of{" "}
              <Link to="/mobile-app-development-company-dubai">
                mobile app development in Dubai
              </Link>{" "}
              – that’s our formula to be the most reliable app development
              company in Dubai and help UAE-based businesses grow with
              performant and success mobile apps.
            </p>
          </Col>

          <Col xs={12} md={12} lg={12} className="mt-4">
            <div className="winning_image">
              <StaticImage
                src="../../images/locationgcc/dubai_new/table_image_new.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1920}
                height={720}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Winningdubai;
